import { Component } from '@angular/core';
import { LockerListComponent } from './locker-list/locker-list.component';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@Component({
  selector: 'app-lockers',
  standalone: true,
  imports: [NzGridModule, LockerListComponent, NzSpinModule, NzEmptyModule],
  templateUrl: './lockers.component.html',
  styleUrl: './lockers.component.scss',
})
export class LockersComponent {}
